export const queryKeys = {
  CHATBOT_DETAIL: 'chatbot-detail',
  CONVERSATION_HISTORY_KEY: 'history',
  SEND_CONVERSATION_KEY: 'sendConversation',
  CREATE_LEAD_KEY: 'createLead',
  REACTIONS: 'reactions',
};
